// This is the ApiOps file, it's responsible for fetching data from the API and managing the data in the React Query cache.
import { QueryClient, useQuery } from "react-query";

// This is the QueryClient with options so that queries remain fresh and are garbage collected after a certain time
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20 * 60 * 1000, // 20 minutes before considering data stale
      cacheTime: 30 * 60 * 1000, // 30 minutes before garbage collection
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: 2,
    },
  },
});

export type Product = {
  id_produto: number;
  id_categoria: number;
  nome: string;
  imagem: string;
  pdf: string | null;
  descricao: string;
  subcategoria: string;
  categoria: string;
};

// const path = "https://rdec-backend.onrender.com";
const path = "https://marine-lucienne-avli-solutions-0d26a3f8.koyeb.app";

// Fetch all portfolio products from the API
export const fetchPortfolio = async () => {
  const res = await fetch(`${path}/portfolio/`);
  if (!res.ok) {
    throw new Error("Error fetching portfolio data");
  }
  const data: Product[] = await res.json();
  // HIMA desabilitado: oculta os produtos da categoria "Automação e Controle" (todos são HIMA)
  return data.filter((p) => p.categoria !== "Automação e Controle");
};

// Hook to use portfolio data in your components
export const usePortfolio = () => {
  return useQuery("portfolio", fetchPortfolio);
};

// Fetch a single portfolio item by its ID
export const fetchPortfolioItem = async (id: string) => {
  const res = await fetch(`${path}/portfolio/${id}`);
  if (!res.ok) {
    throw new Error("Error fetching portfolio item");
  }
  const data = await res.json();
  // HIMA desabilitado: bloqueia acesso direto a produtos da categoria "Automação e Controle" (todos são HIMA)
  if (Array.isArray(data)) {
    return data.filter((p: Product) => p.categoria !== "Automação e Controle");
  }
  return data;
};

// Function to pre-render (prefetch) the portfolio data when the site is loaded
export const preRenderQueries = async () => {
  await queryClient.prefetchQuery("portfolio", fetchPortfolio);
};
